<template>
  <div class="user_record">
    <div v-lazy:background-image="pageCover" class="page_cover">
      <div class="my">
        <img v-lazy="userprofile.avatar_url" class="headimg">
        <p>{{ userprofile.nickname }}</p>
      </div>
    </div>

    <van-cell class="mt2" title="打卡记录" />
    <van-list
      v-model="loading"
      finished-text="没有更多了"
      :finished="finished"
      :immediate-check="true"
      @load="onLoad"
    >
      <record-panel
        class="bgwhite"
        v-for="(item, index) in list"
        :key="index"
        :record="item"
        :has-footer="true"
        :has-toolbar="false"
      />
    </van-list>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { Cell, List } from 'vant'
import RecordPanel from '@/views/record/components/RecordPanel'
import { userRecordList } from '@/api/record'

export default {
  name: 'userRecord',
  components: {
    [Cell.name]: Cell,
    [List.name]: List,
    RecordPanel
  },
  data () {
    return {
      pageCover: 'http://ws3.sinaimg.cn/large/006tNc79gy1g028b6j2knj30ku0afaag.jpg',
      isLoad: false,
      list: [],
      loading: false,
      pullLoading: false,
      finished: false,
      listQuery: {
        user: '',
        status: 1,
        page: 0,
        size: 8
      }
    }
  },
  computed: {
    ...mapGetters([
      'userprofile'
    ]),
    noList () {
      return this.isLoad && !this.list.length
    }
  },
  created () {
    this.listQuery.user = this.$route.params.user_id || ''
  },
  methods: {
    async getList () {
      this.loading = true
      let response = await userRecordList(this.listQuery)
      this.loading = false
      this.list = this.list.concat(response.data.results)
      this.checkFinished(response.data.count)
    },
    onLoad () {
      this.listQuery.page += 1
      this.getList()
    },
    checkFinished (total) {
      this.finished = this.list.length >= total
    }
  }
}
</script>

<style scoped lang="scss">
.user_record {
  .page_cover {
    width: 750px;
    height: 330px;
    background-size: cover;
    color: #fff;
    font-size: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    .my {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
    .headimg {
      width: 110px;
      height: 110px;
      border: 2PX solid #fff;
      border-radius: 50%;
      margin-bottom: 20px;
    }
  }
  .clazz_panel {
    width: 680px;
    height: 150px;
    margin: 35px 0 0 35px;
    background-size: cover;
    position: relative;
    color: #fff;
    .bg {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      background:rgba(0,0,0,0.6);
    }
    .title {
      font-size: 30px;
      font-weight: bold;
      margin-top: 30px;
      margin-left: 30px;
    }
    .detail {
      font-size: 23px;
      color: rgb(226, 221, 221);
      margin-top: 15px;
      margin-left: 30px;
    }
  }
}
</style>
